// extracted by mini-css-extract-plugin
export default {"cropSurface":"eS6rNswBnDIcFjPua4mz"};